import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsX } from "react-icons/bs";

const CancelRefereeModal = ({
  visible,
  close,
  onCancel,
  loading = false
}) => {
  return (
    <Modal show={visible} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title className="text-capitalize">
          <h1 className="text-axis-offblack icon-text-wrapper">
            <BsX className="icon-right-spacing" />
            Cancel Reference
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Cancellation Reason (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter reason for cancellation..."
              disabled={loading}
              id="cancelReasonInput"
            />
            <Form.Text className="text-muted">
              If no reason is provided, "Cancelled by admin" will be used.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={close}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={() => {
            const reason = document.getElementById('cancelReasonInput').value;
            onCancel(reason);
          }}
          disabled={loading}
        >
          {loading ? "Cancelling..." : "Cancel Reference"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelRefereeModal;